import ExpandedHeader from "./ExpandedHeader";
export default ExpandedHeader;
